import { render, staticRenderFns } from "./DialogProfileUserPermission.vue?vue&type=template&id=3c1343ca&"
import script from "./DialogProfileUserPermission.vue?vue&type=script&lang=js&"
export * from "./DialogProfileUserPermission.vue?vue&type=script&lang=js&"
import style0 from "./DialogProfileUserPermission.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c1343ca')) {
      api.createRecord('3c1343ca', component.options)
    } else {
      api.reload('3c1343ca', component.options)
    }
    module.hot.accept("./DialogProfileUserPermission.vue?vue&type=template&id=3c1343ca&", function () {
      api.rerender('3c1343ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DialogProfileUserPermission.vue"
export default component.exports